import { render, staticRenderFns } from "./StockTransfer.vue?vue&type=template&id=58d6b925&"
import script from "./StockTransfer.vue?vue&type=script&lang=ts&"
export * from "./StockTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./StockTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports